import fetchData from "./axios-instance";
import {getAuthorizationHeader} from "../helpers/get-token";

const validateOpt = async (userId, token) => {
    const url = `/validate-opt`;
    const res = await fetchData.post(url, {"userId": userId, "token": token});
    return res;
}

export default validateOpt;